import IRankingsPair from '../../../../interfaces/IRankingsPair';
import IApplicationReviewForm from '../../../../interfaces/IApplicationReviewForm';

const useAlgorithmCalculator = () => {
    const _calculatePartScore = (data: IRankingsPair) => {
        return Object.values(data).reduce((total, value) => total + (value > 2 ? value : 0), 0);
    };

    const calculateScore = (formData: IApplicationReviewForm): number => {
        const partAScore = formData.partA
            ? _calculatePartScore(formData.partA.value as IRankingsPair)
            : 0;
        const partBScore = formData.partB
            ? formData.partB
                  .flatMap((i) => i.value)
                  .flatMap((i) => i.value)
                  .map(_calculatePartScore)
                  .reduce((total, value) => total + value, 0)
            : 0;
        const partCScore = formData.partC
            ? _calculatePartScore(formData.partC.value as IRankingsPair)
            : 0;

        return partAScore + partBScore + partCScore;
    };

    return {
        calculateScore,
    };
};

export default useAlgorithmCalculator;
